import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const initialState = {
  view: 'mnpInStart',
  portationTime: [],
  portationConsent: false,
  portationMsisdn: null,
  selectedKeys: {
    networkKey: null,
    providerKey: null
  },
  person: {
    gender: null,
    firstName: null,
    lastName: null,
    birthDate: null
  },
  result: {}
}
const MnpInModule = {
  namespaced: true,
  state: initialState,
  actions: {
    async storeAllStartData ({ commit, state, getters, rootGetters }, {
      portationTime,
      portationConsent,
      nextStep
    }) {
      commit('storePortationTime', portationTime)
      commit('storePortationConsent', portationConsent)
      commit('mnpIn/goToStep', nextStep, { root: true })
    },
    async storePersonData ({ commit, state, getters, rootGetters }, { person, portationMsisdn, selectedKeys, nextStep }) {
      commit('storePortationMsisdn', portationMsisdn)
      commit('storeSelectedKeys', selectedKeys)
      commit('storePerson', person)
      commit('mnpIn/goToStep', nextStep, { root: true })
    },
    async performMnpIn ({ commit, state, getters }, { person, portationMsisdn, selectedKeys, nextStep }) {
      const apolloClient = getProvider().defaultClient
      commit('clearMessages', {}, { root: true })
      return apolloClient.mutate({
        mutation: gql`
          mutation mnpIn ($mnpInput: MnpInput!) {
          performMnpIn (mnpInput: $mnpInput) {
            contractId
            success
          },
        }`,
        variables: {
          mnpInput: {
            consent: state.portationConsent,
            person: {
              gender: person.gender,
              firstName: person.firstName,
              lastName: person.lastName,
              birthdate: person.birthDate
            },
            portation: {
              executionDate: state.portationTime,
              msisdn: portationMsisdn,
              network: selectedKeys.networkKey,
              provider: selectedKeys.providerKey
            }
          }
        }
      }).then((response) => {
        if (response.data.performMnpIn.success === true) {
          commit('storePortationMsisdn', portationMsisdn)
          commit('storeSelectedKeys', selectedKeys)
          commit('storePerson', person)
          commit('storeResult', response.data.performMnpIn)
          commit('Transaction/removeTransactionId', 'mnpIn', { root: true })
          commit('mnpIn/goToStep', nextStep, { root: true })
        } else {
          commit('addMessage', {
            type: 'danger',
            message: 'Ein Fehler ist aufgetreten. Bitte wenden Sie sich an die LIDL Connect Kundenbetreuung.'
          }, { root: true })
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    goToStep (state, step) {
      state.view = step
    },
    storePortationTime (state, portationTime) {
      state.portationTime = portationTime
    },
    storePortationConsent (state, portationConsent) {
      state.portationConsent = portationConsent
    },
    storePortationMsisdn (state, portationMsisdn) {
      state.portationMsisdn = portationMsisdn
    },
    storeSelectedKeys (state, selectedKeys) {
      state.selectedKeys = selectedKeys
    },
    storePerson (state, person) {
      state.person = person
    },
    storeResult: (state, result) => {
      state.result = result
    }
  },
  getters: {
    showMnpInView: state => {
      return state.view
    },
    portationConsent: (state) => {
      return state.portationConsent
    },
    portationTime: (state) => {
      return state.portationTime
    },
    portationMsisdn: (state) => {
      return state.portationMsisdn
    },
    selectedKeys: (state) => {
      return state.selectedKeys
    },
    person: (state) => {
      return state.person
    }
  }
}

export {
  MnpInModule
}
